module.exports = __webpack_public_path__ + "media/ok.715584c7.mp3";